/**
 * Motion system foundation (build-prompt Phase 4 / Global rule 5).
 *
 * Tokens (CSS variables in globals.css, Tailwind: `ease-motion`,
 * `duration-fast|base|slow`):
 *   --wtm-ease      cubic-bezier(.22, 1, .36, 1)   the ONE easing
 *   --wtm-dur-fast  150ms                          micro-interactions
 *   --wtm-dur-base  300ms                          standard transitions
 *   --wtm-dur-slow  600ms                          reveals + count-ups
 *
 * Hooks (all gated behind prefers-reduced-motion → completed end states):
 *   useReveal()       reveal-on-scroll (.rv classes, 60ms sibling stagger)
 *   useCountUp()      600ms ease-out numeral count-up
 *   useStageDriver()  clock driver for pure stage-function animations
 *                     (hover pause, clickable markers, viewport pause)
 *   frameAt() / progressAtStage()  pure timeline math for tests + future
 *                     scrub drivers
 */

export { prefersReducedMotion, usePrefersReducedMotion } from "./reduced-motion";
export { useReveal } from "./use-reveal";
export { useCountUp, type UseCountUpOptions } from "./use-count-up";
export {
  useStageDriver,
  frameAt,
  progressAtStage,
  type StageFrame,
  type StageDriver,
  type UseStageDriverOptions,
} from "./use-stage-driver";
